var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIconAddCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09013 9.99747C5.3708 10.278 5.82587 10.2779 6.10644 9.99747C6.38721 9.71671 6.38721 9.26173 6.10634 8.98097L3.34469 6.21941L11.3419 6.21864C11.7388 6.21854 12.0605 5.89686 12.0605 5.49976C12.0604 5.10286 11.7387 4.78127 11.3418 4.78127L3.3443 4.78204L6.10663 2.0199C6.3873 1.73923 6.3873 1.28407 6.10663 1.00349C5.96625 0.863208 5.78236 0.792969 5.59838 0.792969C5.41449 0.792969 5.23061 0.863208 5.09022 1.0034L1.10115 4.99237C0.966326 5.1271 0.890625 5.30984 0.890625 5.50053C0.890721 5.69122 0.966422 5.87386 1.10125 6.00888L5.09013 9.99747Z",
    fill: "#C2D0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconAddCustomer);
export default __webpack_public_path__ + "static/media/backIconAddCustomer.d136a3b4d6050e4b6894c8bd2e20fe1b.svg";
export { ForwardRef as ReactComponent };